import Vue from 'vue'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import de from '../i18n/de.json'

const i18n = new VueI18n({
  locale: 'de', // set locale
  messages: {
    'de': de
  }
})

import {
  Alert,
  //Button,
  //Card,
  //Carousel,
  //CarouselItem,
  Checkbox,
  //Divider,
  CheckboxGroup,
  Row,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  TimePicker,
  //Dropdown,
  //DropdownMenu,
  //DropdownItem,
  Dialog,
  //Form,
  //FormItem,
  Icon,
  Input,
  //InputNumber,
  //Menu,
  //Submenu,
  //MenuItem,
  Option,
  OptionGroup,
  //Radio,
  Select,
  //Switch,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  //Upload,
  //Tag,
  Loading,
  MessageBox,
  Message,
  Notification
  //Progress,
  //Popover,
  //Tooltip
} from 'element-ui';

import localeDe from 'element-ui/lib/locale/lang/de'
import locale from 'element-ui/lib/locale'
locale.use(localeDe)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(Alert, { localeDe })
Vue.use(Checkbox, { localeDe })
Vue.use(Row, { localeDe })
Vue.use(Col, { localeDe })
Vue.use(CheckboxGroup, { localeDe })
Vue.use(Tabs, { localeDe })
Vue.use(TabPane, { localeDe })
Vue.use(Table, { localeDe })
Vue.use(TableColumn, { localeDe })
Vue.use(Collapse, { localeDe })
Vue.use(CollapseItem, { localeDe })
Vue.use(Dialog, { localeDe })
Vue.use(Icon, { localeDe })
Vue.use(Loading, { localeDe })
Vue.use(TimePicker, { localeDe })
Vue.use(DatePicker, { localeDe })
Vue.use(Select, { localeDe })
Vue.use(Option, { localeDe })
Vue.use(OptionGroup, { localeDe })


Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

import 'element-ui/lib/theme-chalk/alert.css'
import 'element-ui/lib/theme-chalk/row.css'
import 'element-ui/lib/theme-chalk/col.css'
import 'element-ui/lib/theme-chalk/checkbox.css'
import 'element-ui/lib/theme-chalk/checkbox-group.css'
import 'element-ui/lib/theme-chalk/tabs.css'
import 'element-ui/lib/theme-chalk/table.css'
import 'element-ui/lib/theme-chalk/table-column.css'
import 'element-ui/lib/theme-chalk/collapse.css'
import 'element-ui/lib/theme-chalk/collapse-item.css'
import 'element-ui/lib/theme-chalk/dialog.css'
import 'element-ui/lib/theme-chalk/icon.css'
import 'element-ui/lib/theme-chalk/loading.css'
import 'element-ui/lib/theme-chalk/select.css'
import 'element-ui/lib/theme-chalk/message-box.css'
import 'element-ui/lib/theme-chalk/time-picker.css'
import 'element-ui/lib/theme-chalk/date-picker.css'


import LteButton from '../components/ui/button.vue'
Vue.component('LteButton', LteButton)

import LteTable from '../components/ui/table.vue'
Vue.component('LteTable', LteTable)

import LteBox from '../components/ui/box.vue'
Vue.component('LteBox', LteBox)

import LteInput from '../components/ui/input.vue'
Vue.component('LteInput', LteInput)

import CurrencyInput from '../components/ui/currencyInput.vue'
Vue.component('CurrencyInput', CurrencyInput)


import Select2 from 'v-select2-component';
Vue.component('Select2', Select2);

$(document).ready(function(){
  window.setCurrentMarketLink()
})

window.setCurrentMarketLink = function(){
  // Add Quicklink to current Market instance on page bottom if ID is set
  if (window.currentMarketInstanceId){

    var currentLink = $("#market-quicklink-container")

    if (currentLink){
      currentLink.remove()
    }

    var marketQuickLinkWrapper = `<div id="market-quicklink-container"><a href="/intern/sms/markets/${window.currentMarketInstanceId}/edit" target="blank">Markt anzeigen</a></div>`
    $(".wrapper .content-wrapper").append(marketQuickLinkWrapper)
  }
}